define("ember-composable-helpers/helpers/map-by", ["exports", "@ember/component/helper", "@ember/object", "@ember/utils", "ember-composable-helpers/utils/as-array"], function (_exports, _helper, _object, _utils, _asArray) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.mapBy = mapBy;
  function mapBy(_ref) {
    let [byPath, array] = _ref;
    if ((0, _utils.isEmpty)(byPath)) {
      return [];
    }
    return (0, _asArray.default)(array).map(item => (0, _object.get)(item, byPath));
  }
  var _default = _exports.default = (0, _helper.helper)(mapBy);
});